import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=af8b2bb6&scoped=true"
import script from "./preview.vue?vue&type=script&lang=ts"
export * from "./preview.vue?vue&type=script&lang=ts"
import style0 from "./preview.vue?vue&type=style&index=0&id=af8b2bb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8b2bb6",
  null
  
)

export default component.exports